// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "wrapper-u1Agd";
var _4 = "button-3zApn";
export { _1 as "__esModule", _2 as "mobile", _3 as "wrapper", _4 as "button" }
export default { "__esModule": _1, "mobile": _2, "wrapper": _3, "button": _4 }
